import React, { ReactNode } from "react";
import './antdModal.scss';
import { Modal, ModalProps } from "antd";

export interface IAntdModal extends ModalProps {
  className?: string;
  children?: ReactNode;
}

const AntdModal = (props?: IAntdModal) => {
  const { className, children, cancelButtonProps, ...modalProps } = props || {};

  return (
    <Modal
      className={`antd-modal ${className}`}
      cancelButtonProps={{
        type: "primary",
        className: "antd-modal__cancel-btn",
        ...cancelButtonProps
      }}
      {...modalProps}
    >
      {children}
    </Modal>
  )
};

export default AntdModal;